import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Button } from '../Button/Button.js';
export function CodeBlock({ label, code, copyLabel = 'Copy', masked = false, onCopied }) {
    const [state, setState] = useState('idle');
    const [announce, setAnnounce] = useState('');
    const timer = useRef(null);
    useEffect(() => () => { if (timer.current)
        clearTimeout(timer.current); }, []);
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(code);
            setState('copied');
            setAnnounce('');
            // Clear then set, so a second copy of the same block is announced again.
            requestAnimationFrame(() => setAnnounce(`${label} copied.`));
            onCopied?.();
        }
        catch {
            setState('failed');
            setAnnounce('Copy was unavailable. Select the text and copy it.');
        }
        if (timer.current)
            clearTimeout(timer.current);
        timer.current = setTimeout(() => setState('idle'), 2000);
    };
    return (_jsxs("div", { "data-code-block": true, style: { display: 'grid', gap: 'var(--space-2)' }, children: [_jsx("div", { role: "region", "aria-label": label, tabIndex: 0, style: {
                    margin: 0,
                    padding: 'var(--space-3)',
                    background: 'var(--surface-elevated)',
                    border: '1px solid var(--border)',
                    borderRadius: 'var(--radius-md)',
                    overflow: 'auto',
                    maxHeight: '24rem',
                }, children: _jsx("pre", { style: {
                        margin: 0,
                        fontFamily: 'var(--font-mono)',
                        fontSize: 'var(--font-size-3xs)',
                        lineHeight: 1.5,
                        color: 'var(--text)',
                        whiteSpace: 'pre',
                    }, children: masked ? '•'.repeat(Math.min(code.length, 32)) : code }) }), _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }, children: [_jsx(Button, { variant: "secondary", compact: true, onClick: () => void copy(), children: state === 'copied' ? 'Copied' : copyLabel }), _jsx("span", { role: "status", "aria-live": "polite", style: { color: 'var(--text-muted)', fontSize: 'var(--font-size-3xs)' }, children: state === 'failed' ? announce : _jsx("span", { style: { position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }, children: announce }) })] })] }));
}
//# sourceMappingURL=CodeBlock.js.map